import Button from "../lib/Button";

import { fetchAPINew } from "../../utils/fetch";

function DownloadPOSTButton({
  children,
  getFormData,
  onClick,
  onSuccess,
  onError,
  ...props
}) {
  async function downloadExcelFile(data) {
    const response = await fetchAPINew("/api/excelsior/v1/excel-export/", {
      method: "POST",
      headers: {
        "content-type": "application/json",
        accept: "application/vnd.ms-excel",
      },
      body: { data },
    });

    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

    const blob = await response.blob();

    // Create download link
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;

    // Try to get filename from response headers
    const contentDisposition = response.headers.get("Content-Disposition");
    let filename = "worksheet-export.xlsx";
    if (contentDisposition) {
      const filenameMatch = contentDisposition.match(
        /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
      );
      if (filenameMatch && filenameMatch[1]) {
        filename = filenameMatch[1].replace(/['"]/g, "");
      }
    }

    link.download = filename;
    document.body.appendChild(link);
    link.click();

    // Cleanup
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  }

  async function handleSubmit(e) {
    if (onClick) onClick(e);

    try {
      let promise = getFormData();
      if (!(promise instanceof Promise)) {
        promise = Promise.resolve(promise);
      }

      const formData = await promise;

      if (!formData) {
        return Promise.resolve();
      }

      await downloadExcelFile(formData);

      if (onSuccess) {
        onSuccess();
      }
    } catch (error) {
      if (error.name !== "AbortError") {
        console.error("Download failed:", error);
        if (onError) {
          onError(error);
        }
      }
    }
  }

  return (
    <Button css={{ fontSize: "14px" }} {...props} onClick={handleSubmit}>
      {children}
    </Button>
  );
}

export default DownloadPOSTButton;
